// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"315":"77857a7755ebce468502","655":"5a72cf8c8b6131d21ad1"}[chunkId] + "." + chunkId + ".web.js";
};